import {I18n} from "react-i18nify";

/* eslint-disable-next-line max-params */
export default (prevProps, props, section, property, elRef) => {
    if (prevProps[property] !== props[property] && props[property] &&
        (elRef && elRef.current || typeof elRef === "undefined")) {
        props.trackError(I18n.t(`${section ? section + "." : ""}${props[property]}`));
    }
};
